import { permissionList } from "helpers";

export type ConnectedPermissionType = {
	parent: string;
	children: string[];
}[];

export const connectedPermissions: ConnectedPermissionType = [
	{
		parent: permissionList.EditExistinScheduleAOrResidualSplitProfileForAgentOfficeOrAgent,

		children: [
			permissionList.ViewScheduleAsResidualSplitProfilesOfAgentOffice,
			permissionList.ViewPrivateResidualSplits,
		],
	},
];
